import React, { useState, useEffect } from 'react';
import Popup from "reactjs-popup";
import { connect } from 'react-redux';
import { nextStep, LibPlanAdd, ifloorplanStateAdd, setUpdatePlanImage } from '../redux/actions/actions';
import { deleteSinglePlan } from '../serverRequests/requests';

const PlanLibrary = (props) => {
    const [change, setChange] = useState(true);
    const [checkedId, setCheckedId] = useState(null);
    const [deletePopup, setDeletePopup] = useState(false);
    const [deleteID, setDeleteID] = useState(false);
    let nowUsePlan = props.ifloorplanNowState.level[props.levelNowId].plan_level[0]?.img;
    const items = [];
    let button = true;
    let checked = "";
    const ifloorplanObj = props.ifloorplanNowState;
    const Select = () => {
        for (let i = 0; i < props.LibraryPlans.length; i++) {
            if (props.LibraryPlans[i].id === checkedId) {
                setDefaultPlanSize(props.LibraryPlans[i]);
            }
        }
    }

    const setDefaultPlanSize = (img) => {
        let plan = new Image();
        plan.style.width = "100%";
        plan.onload = (src) => {
            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
            const oldCrop = {
                width: newState.level[props.levelNowId].plan_level[0]?.crop_width || 1,
                height: newState.level[props.levelNowId].plan_level[0]?.crop_height || 1,
                x: newState.level[props.levelNowId].plan_level[0]?.crop_x || 0,
                y: newState.level[props.levelNowId].plan_level[0]?.crop_y || 0,
            };
            const newCrop = {
                width: 1,
                height: 1,
                x: 0,
                y: 0,
            };
            const planImg = {
                img: img.plan_image,
                img_id: img.id,
                crop_x: 0,
                crop_y: 0,
                crop_width: 1,
                crop_height: 1,
            }
            newState.level[props.levelNowId].plan_width = plan.width / plan.height < 8 / 9 ? (plan.width * 50.625 / plan.height) : 45;
            newState.level[props.levelNowId].plan_level[0] = planImg;
            newState.level[props.levelNowId].images.forEach((value, index) => {
                if (value.cam_pos_x !== 0) {
                    value.cam_pos_x = (oldCrop.width * value.cam_pos_x / 100 - newCrop.x + oldCrop.x) / newCrop.width * 100;
                    value.cam_pos_y = (oldCrop.height * value.cam_pos_y / 100 - newCrop.y + oldCrop.y) / newCrop.height * 100;
                }
            });
            newState.level[props.levelNowId].panelum.forEach((value, index) => {
                if (value.pos_x !== 50) {
                    value.pos_x = (oldCrop.width * value.pos_x / 100 - newCrop.x + oldCrop.x) / newCrop.width * 100;
                    value.pos_y = (oldCrop.height * value.pos_y / 100 - newCrop.y + oldCrop.y) / newCrop.height * 100;
                }
            });
            props.ifloorplanStateAdd(newState);
            props.nextStep("cams position", props.step);
        }
        plan.src = img.plan_image;
    }

    const Cancel = () => {
        if (ifloorplanObj.level[props.levelNowId].plan_level[0].img === "") {
            props.nextStep("single plan upload", props.prev_step);
            return 1;
        }
        if (ifloorplanObj.level[props.levelNowId].images.length === 0) {
            props.nextStep("upload images", "_");
        } else {
            props.nextStep("cams position", "_");
        }
    }

    const Checked = (id) => {
        setChange(false);
        setCheckedId(id);
    }

    const Upload = () => {
        props.nextStep("single plan upload", props.prev_step);
    }

    const deletePlan = (id) => {
        if (id) {
            let form_data = {
                ifloorplan_id: ifloorplanObj.id,
                level_id: ifloorplanObj.level[props.levelNowId].id,
                id: id,
            };
            deleteSinglePlan(form_data)
                .then(data => {
                    let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                    for (let i = 0; i < newState.level.length; ++i) {
                        if (newState.level[props.levelNowId].plan_level[0].img_id == id) {
                            newState.level[props.levelNowId].plan_level[0].img = null;
                        }
                    }
                    props.ifloorplanStateAdd(newState);
                    props.setAnimation(animationSaved => animationSaved + 1);
                    props.LibPlanAdd(data);
                });

            setDeletePopup(false);
            setDeleteID(false);
        };

    };

    const usePopUp = (id) => {
        setDeletePopup(true);
        setDeleteID(id);

    };

    for (let i = 0; i <= 11; i++) {
        if (props.LibraryPlans[i] == undefined) {
            if (button) {
                items.push(
                    <div className="planItem btnAdd" key={i}>
                        <div className="image">
                            <button onClick={Upload}>Upload a floor plan</button>
                        </div>
                    </div>
                )
                button = false;
            } else {
                items.push(<div className="planItem" key={i}><div className="image"></div></div>)
            }
        } else {
            if ((nowUsePlan === props.LibraryPlans[i].plan_image) && change) {
                checked = <div className="checked"><i className="fa fa-check" aria-hidden="true"></i></div>;
            }
            if (!change && props.LibraryPlans[i].id === checkedId) {
                checked = <div className="checked"><i className="fa fa-check" aria-hidden="true"></i></div>;
            }
            items.push(
                <div className="planItem" onClick={() => Checked(props.LibraryPlans[i].id)} key={i}>{checked}<div className="image"><img src={props.LibraryPlans[i].plan_image} alt="" /></div>
                    <div className="options">
                        <div>
                            <img title='Replace this image' style={{ height: '13px', cursor: 'pointer', marginRight: '6px' }} rel="shortcut icon" type="image/png" src="/static/public/img/library-replace-icon.svg" onClick={() => { props.setUpdatePlanImage(props.LibraryPlans[i].id); props.nextStep("single plan update image", "_") }} />
                            {/* <i className="fa fa-plus" aria-hidden="true" onClick={()=>{props.setUpdatePlanImage(props.LibraryPlans[i].id); props.nextStep("single plan update image", "_")}}></i> */}
                        </div>
                        {/* <i className="fa fa-minus" aria-hidden="true" onClick={() => usePopUp(props.LibraryPlans[i].id)}></i> */}
                        <img title='Delete this image' style={{ height: '13px', cursor: 'pointer', marginTop: '-4px' }} rel="shortcut icon" type="image/png" src="/static/public/img/library-delete-icon.svg" onClick={() => usePopUp(props.LibraryPlans[i].id)} />
                    </div>
                </div>)
            checked = "";
        }
    }

    useEffect(() => {
        if (props.setShowTools)
            props.setShowTools(true);
    }, [])

    return (
        <div className="planLibrary">

            <Popup
                open={deletePopup}
                closeOnDocumentClick
                onClose={() => setDeletePopup(false)}>

                <div className="modal">
                    <p className="title_modal">Are you sure you want to delete this floor plan?</p><br />
                    <p className="description_modal">This action cannot be undone.</p>
                    <div className="btnGroup">
                        <button onClick={() => setDeletePopup(false)}>Cancel</button>
                        <button onClick={() => deletePlan(deleteID)}>Delete floor plan</button>
                    </div>
                </div>
            </Popup>

            <div className="titleBlock">
                <div className='planLibraryPanel'>
                    <h3>Floor plan Library</h3>
                    <div className="btnGroup">
                        <button onClick={Cancel}>Cancel</button>
                        <button onClick={Select}>Use selected Floor plan</button>
                    </div>
                </div>
                <p>Click a floor plan to select</p>
            </div>
            <div className="plansLib">
                {items}
            </div>

        </div>
    )
}

const putState = (state) => {
    return {
        step: state.step,
        LibraryPlans: state.LibraryPlans,
        ifloorplanNowState: state.ifloorplanNowState,
        prev_step: state.prev_step,
        levelNowId: state.levelNowId,
        image_key: state.image_key,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        LibPlanAdd: (array) => dispatch(LibPlanAdd(array)),
        setUpdatePlanImage: (id) => dispatch(setUpdatePlanImage(id))
    }
}

export default connect(putState, putActions)(PlanLibrary);
